export default __webpack_public_path__ + "static/taskdefinition4-1af0b1431599922b6d7429a041b2a458.png";